import { CostCalculation } from '@forms/CostCalculation'

import { config } from './config'
import { Description } from './Description'
import { FinalProduct } from './FinalProduct'
import { MarketAnalysis } from './MarketAnalysis'
import { PageHeader } from './PageHeader'
import { Process } from './Process'
import { Results } from './Results'
import { PageContent } from './styles'
import { Team } from './Team'

const {
  pageHeader,
  marketAnalysis,
  client,
  challenge,
  team,
  process,
  finalProduct,
  results,
} = config

export function BigDataSolutionForOnlineBank() {
  return (
    <>
      <PageHeader {...pageHeader} />
      <PageContent>
        <MarketAnalysis {...marketAnalysis} />
        <Description {...client} />
        <Description {...challenge} />
        <Team {...team} />
      </PageContent>
      <Process {...process} />
      <PageContent>
        <FinalProduct {...finalProduct} />
        <Results {...results} />
      </PageContent>
      <CostCalculation />
    </>
  )
}
